import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { CREDIT_PROPERTY_KEYS } from 'constants/credit';

import { selectCompanyPropertiesAsObject } from './properties.selectors';

export const selectCreditSettingsInitialValues = memoizeOne(companyId =>
  createSelector([selectCompanyPropertiesAsObject(companyId)], properties => ({
    [CREDIT_PROPERTY_KEYS.CREDIT_REPORT_PROVIDER]:
      properties[CREDIT_PROPERTY_KEYS.CREDIT_REPORT_PROVIDER] || '',
    [CREDIT_PROPERTY_KEYS.CREDIT_PROVIDER_USERNAME]:
      properties[CREDIT_PROPERTY_KEYS.CREDIT_PROVIDER_USERNAME] || '',
    [CREDIT_PROPERTY_KEYS.CREDIT_PROVIDER_PASSWORD]:
      properties[CREDIT_PROPERTY_KEYS.CREDIT_PROVIDER_PASSWORD] || '',
    [CREDIT_PROPERTY_KEYS.CREDIT_PROVIDER_USE_TEST]:
      properties[CREDIT_PROPERTY_KEYS.CREDIT_PROVIDER_USE_TEST] === 'true',
  })),
);
